import axios from 'axios';

import { PUNTO, VENTAS } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarProductos = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/punto/listar_productos`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PUNTO.BUSCAR_PRODUCTOS,
            payload: res.data.productos
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarServicios = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/punto/listar_servicios`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PUNTO.BUSCAR_SERVICIOS,
            payload: res.data.servicios
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarPaquetesPunto = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/punto/listar_paquetes`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PUNTO.BUSCAR_PAQUETES,
            payload: res.data.paquetes
        });
    } catch (error){
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarComandas = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/punto/listar_comandas`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PUNTO.BUSCAR_COMANDAS,
            payload: res.data.comandas
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarMedicos = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/punto/listar_medicos`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PUNTO.BUSCAR_MEDICOS,
            payload: res.data.medicos
        });
    } catch (error){
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarMedicosExternos = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/punto/listar_medicos_externos`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: PUNTO.BUSCAR_MEDICOS_EXTERNOS,
            payload: res.data.medicos_externos
        });
    } catch (error){
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const crearVenta = (venta) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(venta);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/punto/crear`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: VENTAS.DETALLES,
            payload: res.data.venta
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        await dispatch(changeLoader(false));
        
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const editarVenta = (venta) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(venta);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/punto/editar`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: VENTAS.DETALLES,
            payload: res.data.venta
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        await dispatch(changeLoader(false));
        
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}